// extracted by mini-css-extract-plugin
module.exports = {"languageSelector":"styles_languageSelector__2dEtH","languagePicker":"styles_languagePicker__3-l9B","langOption":"styles_langOption__1KXC1"};